export const extractBlogIdFromURL = (): number | null => {
    const path = window.location.pathname;
    const pathSegments = path.split("/");
    const blogId = pathSegments[2];
    return blogId ? Number(blogId) : null;
};